var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvasContainer",class:{'ruler-horizontal': _vm.isHorizontal, 'ruler-vertical': _vm.isVertical}},[_c('canvas',{ref:"rulerCanvas",staticClass:"ruler-canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }